import axios from 'axios'
import { VueAxios } from './axios'
// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 5000 // 请求超时时间
})

// 异常拦截处理器
const errorHandler = (error) => {
  if (error) {
    window.vm.$notify.error({
      title: '错误',
      message: error.message
    })
  }
  return Promise.reject(error)
}
var loading = "";
// request interceptor
request.interceptors.request.use(config => {
  loading = window.vm.$loading({
    lock: true,
    text: '',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)',
    customClass: 'my-custom-loading'
  });
  return config
}, errorHandler)

// response interceptor
request.interceptors.response.use((response) => {
  loading.close();
  return response
}, errorHandler)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, request)
  }
}

export default request

export {
  installer as VueAxios,
  request as axios
}
